/**
 * Created by Olexiy on 27.02.2017.
 */

(function($){
    $(document).ready(function() {
        var streamOverlayHTML = '<div class="stream-overlay"></div>';
        var streamWrapperHTML = '<div class="stream-wrapper"></div>';
        var streamInner = $('.stream-inner');
        var streamHelper = $('.stream-helper');
        var streamIsOpen = false;
        var $cookieKeyInput = $('input.cookie-key');

        LiveStream = {};

        if($('body').hasClass('home') && $cookieKeyInput.length > 0) {
            LiveStream.cookieKey = $cookieKeyInput.val().length ?  $cookieKeyInput.val() : 'dont_show_again';
        }

        function setCookie(name, value, options) {
            options = options || {};
            var expires = options.expires;

            if (typeof expires === "number" && expires) {
                var d = new Date();
                d.setTime(d.getTime() + expires * 1000);
                expires = options.expires = d;
            }
            if (expires && expires.toUTCString) {
                options.expires = expires.toUTCString();
            }

            value = encodeURIComponent(value);

            var updatedCookie = name + "=" + value;

            for (var propName in options) {
                updatedCookie += "; " + propName;
                var propValue = options[propName];
                if (propValue !== true) {
                    updatedCookie += "=" + propValue;
                }
            }

            document.cookie = updatedCookie;
        }

        function getCookie(name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length === 2) {
              return parts.pop().split(";").shift();
            }
        }

        function setStreamPosition(elem,position) {
            var elemWidth = elem.outerWidth();
            var elemHeight = elem.outerHeight();
            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;

            if(position === 'center') {
                elem.css({
                    top:(windowHeight-elemHeight)/2 + 'px',
                    left:(windowWidth-elemWidth)/2 + 'px'
                });
            }
        }

        var cookieInfo = getCookie(LiveStream.cookieKey);

        LiveStream.showPopup = function() {
            var streamWrapper;
            var streamContent;
            var streamOverlay;
            if(streamInner.length) {
                $('body').append(streamWrapperHTML).append(streamOverlayHTML);
                streamWrapper = $('.stream-wrapper');
                streamContent = $('.stream-content');
                streamOverlay = $('.stream-overlay');
                streamWrapper.append(streamInner);
                if(streamContent.attr('data-autoplay')) {
                    streamContent.find('iframe').attr('src',streamContent.find('iframe').attr('src') + streamContent.attr('data-autoplay'));
                }
                setTimeout(function() {
                    setStreamPosition(streamWrapper,'center');
                },100);
                streamOverlay.click(function() {
                    if(streamInner.hasClass('stream')) {
                        streamOverlay.hide();
                        streamWrapper.addClass('sticky');
                    }
                });
                streamIsOpen = true;
            }
        };

        $(window).resize(function() {
            if(streamIsOpen) {
                setStreamPosition($('.stream-wrapper'),'center');
            }
        });

        LiveStream.hidePopup = function() {
            var streamContent = $('.stream-content');
            if(streamContent.attr('data-autoplay')) {
                var src = streamContent.find('iframe').attr('src');
                src = src.substring(0, src.indexOf(streamContent.attr('data-autoplay')));
                streamContent.find('iframe').attr('src',src);
            }
            streamHelper.append(streamInner);
            $('.stream-overlay').remove();
            $('.stream-wrapper').removeClass('sticky').remove();
            streamIsOpen = false;
        };

        if(!cookieInfo && $('body').hasClass('home')) {
            LiveStream.showPopup();
        }

        $('.js-open-stream').click(function (e) {
            e.preventDefault();
            if(!streamIsOpen) {
                LiveStream.showPopup();
            }
        });

        $('.js-close-stream').click(function (e) {
            e.preventDefault();
            if($('#newer-show-me').is(':checked')) {
                setCookie(LiveStream.cookieKey,true);
            }
            LiveStream.hidePopup();
        });

        $('.stream-wrapper').click(function(e) {
            e.stopPropagation();
        });
    });
})(jQuery);
